import axios from 'axios';
//import Cookies from 'js-cookie';


const BASE_URL = 'https://ws.abogado.solucionesinteligentes.pro/graphql'; //produccion oficial
//const BASE_URL = 'http://192.168.100.17:8020/graphql'; //workcorp
//const BASE_URL = 'http://192.168.0.2:8080/graphql'; //house
// const BASE_URL = 'http://192.168.100.184:8000/graphql'

const api = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

api.interceptors.request.use((config)=>{
    const token = localStorage.getItem("token");
    if(token){
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error)=>{
    return Promise.reject(error);
});

export {api};

